export { default as TransferOutgoingSolidIcon } from './TransferOutgoingSolidIcon';
